module.exports = __webpack_public_path__ + "img/2_Hills-01.03dbff9a.png";